import React from 'react'

import { styled } from '~/styled'
import { cn } from '~/styled'

export const SectionMessageContent = styled('div', {
  base: ['max-w-full', 'shrink-0', 'pt-0.5', '*:not-last:mb-2']
})

export const SectionMessageActions = ({
  className,
  ...rest
}: React.ComponentProps<'div'>) => (
  <div className={cn('max-w-full', 'shrink-0', className)}>
    <div className="flex flex-wrap gap-3" {...rest} />
  </div>
)
